import React from 'react';
import { RetrospectiveType } from '../api/fe-management-system-api/retrospective';

const RETROSPECTIVE_LABELS: Record<RetrospectiveType, string> = {
  [RetrospectiveType.LATE_RECOGNITION]: '늦은 인지',
  [RetrospectiveType.MISS]: '놓친 기회',
  [RetrospectiveType.EARLY_EXIT]: '조기 매도',
  [RetrospectiveType.LOSS]: '손실',
};

interface RetrospectiveTypeChipProps {
  type: RetrospectiveType;
  className?: string;
}

const RetrospectiveTypeChip: React.FC<RetrospectiveTypeChipProps> = ({ type, className = '' }) => {
  const baseClasses =
    'text-[12px] uppercase tracking-wider px-2 py-0.5 rounded-full border border-red-600 bg-red-900 text-gray-200';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  return <span className={combinedClasses}>{RETROSPECTIVE_LABELS[type] || type}</span>;
};

export default RetrospectiveTypeChip;
